import api from "../index";
import { qs } from "../../utils/utils.js";

export const GetAlllogsApi = (params) => api.get(`admin/get-audit-log-by-userid?${qs(params)}` );
